import { useDispatch, useSelector } from "react-redux";
import "./Header.css";
import { userActions } from "../../actions";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import Modal from "react-modal";
import Button from "../../components/forms/Buttons/Button";
import CertificationFormModal from "../Modals/CertificationFormModal";

function HeaderConnected({ isAuth }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const [showLogOutButton, setShowLogOutButton] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [routeSelected, setRouteSelected] = useState();
  const [initials, setInitials] = useState();
  const formDataChanged = useSelector(
    (state) => state.certificationFormDataReducer.formData
  );

  const generateInitials = useCallback(() => {
    if (user?.data.firstName && user?.data.lastName) {
      setInitials(
        `${user?.data.firstName.charAt(0)}${user?.data.lastName.charAt(0)}`
      );
    } else setInitials(`${user?.data.email.charAt(0)}`);
  }, [user]);

  // Get the current location object using useLocation hook
  const location = useLocation();

  // Custom function to check if the current route is either "/" or "/dashboard"
  const isRouteActive = (route) => {
    return route === "/dashboard"
      ? location.pathname === route || location.pathname === "/"
      : location.pathname === route;
  };

  useEffect(() => {
    if (!isAuth) {
      navigate("/");
    } else {
      generateInitials();
    }
  }, [isAuth, navigate, generateInitials]);

  const handleShowLogoutButton = () => {
    setShowLogOutButton(true);
    setTimeout(() => {
      setShowLogOutButton(false);
    }, 2000);
  };

  const handleLogOut = () => {
    dispatch(userActions.logout());
    navigate("/");
  };

  const handleConfirmationResponse = (keepChanges) => {
    if (!keepChanges) {
      dispatch({ type: "CLEAR_FORM_DATA" });
      navigate(routeSelected);
    }
    setShowConfirmationModal(false);
  };

  const onChangeRoute = (route) => {
    if (route !== "/certification" && formDataChanged) {
      setRouteSelected(route);
      setShowConfirmationModal(true);
    } else {
      console.log("elseee");
      navigate(route);
    }
  };

  return (
    <>
      <header className="z-20">
        <span className="logo">
          <a href={isAuth ? "/dashboard" : "/"}>
            <img src="/assets/images/logo-white.png" alt="" />
          </a>
        </span>
        <ul className="menu">
          <li>
            {formDataChanged ? (
              <NavLink
                className={({ isActive }) =>
                  isRouteActive("/protocol") ? "active" : "none"
                }
                onClick={() => onChangeRoute("/protocol")}
              >
                COC Protocol
              </NavLink>
            ) : (
              <NavLink
                className={({ isActive }) =>
                  isRouteActive("/protocol") ? "active" : "none"
                }
                to="/protocol"
              >
                COC Protocol
              </NavLink>
            )}
          </li>
          {user?.data.userRole === "Client" && (
            <li>
              <NavLink
                className={({ isActive }) => (isActive ? "active" : "none")}
                to="/certification"
              >
                Application form
              </NavLink>
            </li>
          )}
          <li>
            {formDataChanged ? (
              <NavLink
                className={({ isActive }) =>
                  isRouteActive("/dashboard") ? "active" : "none"
                }
                onClick={() => onChangeRoute("/dashboard")}
              >
                Dashboard
              </NavLink>
            ) : (
              <NavLink
                className={({ isActive }) =>
                  isRouteActive("/dashboard") ? "active" : "none"
                }
                to="/dashboard"
              >
                Dashboard
              </NavLink>
            )}
          </li>
          <li>
            {formDataChanged ? (
              <NavLink
                className={({ isActive }) =>
                  isRouteActive("/partners") ? "active" : "none"
                }
                onClick={() => onChangeRoute("/partners")}
              >
                Partners
              </NavLink>
            ) : (
              <NavLink
                className={({ isActive }) =>
                  isRouteActive("/partners") ? "active" : "none"
                }
                to="/partners"
              >
                Partners
              </NavLink>
            )}
          </li>
          <div className="connected flex items-center">
            <div className="user-connected">
              <span>{initials}</span>
            </div>
            <div className="dropdown relative ml-2">
              <img
                className="cursor-pointer"
                src="/assets/icons/dropdown.svg"
                alt=""
                onClick={handleShowLogoutButton}
              />
              {showLogOutButton && (
                <div className="absolute right-0 mt-2 top-11 ">
                  <button
                    className="block flex items-center px-4 py-2 text-gray-800 hover:bg-gray-100 bg-white rounded-md shadow-lg"
                    onClick={handleLogOut}
                  >
                    Logout
                    <img
                      className="ml-2 w-4 h-4"
                      src="/assets/icons/logout.svg"
                      alt=""
                    />
                  </button>
                </div>
              )}
            </div>
          </div>
        </ul>
      </header>
      <CertificationFormModal
        showConfirmationModal={showConfirmationModal}
        handleConfirmationResponse={handleConfirmationResponse}
      />
    </>
  );
}

export default HeaderConnected;
